/** 画像に対応する mime type */
export const ACCEPT_IMAGE_MIME_TYPE = 'image/jpg,image/jpeg,image/png';
/** PDFに対応する mime type */
export const ACCEPT_PDF_MIME_TYPE = 'application/pdf';
/** Microsoftファイルに対応する mime type (.doc .docx .xls .xlsx .ppt .pptx） */
export const ACCEPT_MS_MIME_TYPE = 'application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation';
/** ファイル共有用の mime type (画像、PDF, Microsoft系ファイルを許可） */
export const ACCEPT_SHARE_DOCUMENT_MIME_TYPE = `${ACCEPT_IMAGE_MIME_TYPE},${ACCEPT_PDF_MIME_TYPE},${ACCEPT_MS_MIME_TYPE}`;
/**
 * フォーム内の入力値からFileオブジェクトを取得する
 * @param values
 * @returns {File|null}
 */
const getFileFromValues = (values) => {
    if (values instanceof File) {
        return values;
    }
    if (values) {
        return typeof values.item === 'function' ? values.item(0) : null;
    }
    return null;
};
/**
 * 指定のファイル種別のファイルでアップロードされているか
 * @param acceptType 許容するファイル種別
 * @param text エラー文言
 * @returns {Function}
 */
export const isAllowAcceptTypeFile = (acceptType, text) => (values) => {
    const value = getFileFromValues(values);
    if (!value) {
        return undefined;
    }
    const typeList = acceptType.split('/');
    const valueTypeList = value.type.split('/');
    const checkValues = [
        {
            allowValue: typeList[0],
            checkValue: valueTypeList[0],
        },
        {
            allowValue: typeList[1],
            checkValue: valueTypeList[1],
        },
    ];
    const checked = checkValues.every(({ allowValue, checkValue }) => allowValue === '*' || allowValue === checkValue);
    if (checked) {
        return undefined;
    }
    return text;
};
/**
 * 指定のファイル種別のファイルでアップロードされているか
 * @param acceptTypes 許容するファイル種別の配列
 * @param text エラー文言
 * @returns {Function}
 */
export const isAllowAcceptTypeFiles = (acceptTypes, text) => (values) => {
    const hasAllow = acceptTypes
        .split(',')
        .some((acceptType) => !isAllowAcceptTypeFile(acceptType, text)(values));
    if (hasAllow) {
        return undefined;
    }
    return text;
};
/**
 * 正常なファイルがアップロードされているか
 * @param text エラー文言
 * @returns {Function}
 */
export const isFileValid = (text) => (values) => {
    const value = getFileFromValues(values);
    if (!value) {
        return undefined;
    }
    if (value.size > 0) {
        return undefined;
    }
    return text || '空のファイルが指定されています';
};
/**
 * 指定のMBサイズ以下のファイルが選択されているか
 * @param allowMegaSize 許容サイズ（MB）
 * @param text エラー文言
 * @returns {Function}
 */
export const isAllowMegaSizeFile = (allowMegaSize, text) => (values) => {
    if (!values) {
        return undefined;
    }
    const value = getFileFromValues(values);
    if (!value) {
        return undefined;
    }
    if (value && allowMegaSize * 1024 * 1024 >= value.size) {
        return undefined;
    }
    return text;
};
